'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = require('rp-cookie');

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUTMFirst(currentUTM) {
    _rpCookie2.default.sharedPermanent.set(_constants.COOKIE_UTM_KEY_FIRST, currentUTM);
}

exports.default = setUTMFirst;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/cookie/setUTMFirst.js
// module id = 1808
// module chunks = 0